import {buildHeaders, buildClickbackURL} from '../utils/helpers';
import Promise from "bluebird";
'use strict';
const _ = require('lodash');

// Store the decrypted email in the app state
function storeEmail(email) {
  return {
    type: 'RECEIVE_EMAIL',
    email: email
  };
}

// Store the legalCountry in the app state
function storeLegalCountry(country) {
  return {
    type: 'RECEIVE_LEGALCOUNTRY',
    legalCountry: country
  };
}

// Store the countryBloc in the app state
function storeCountryBloc(bloc) {
  return {
    type: 'RECEIVE_COUNTRYBLOC',
    countryBloc: bloc
  };
}

// Store the first name of the logged in user
function storeLoggedInName(name) {
  return {
    type: 'RECEIVE_NAME',
    name: name
  };
}

// When logged in only use the guestId from the session
function storeGuestId(guestId) {
  return {
    type: 'RECEIVE_GUESTID',
    guestId: guestId
  };
}

function handleClickbackSuccess(email) {
  return {
    type: 'CLICKBACK_SUCCESS'
  };
}

function handleClickbackFailure(email) {
  return {
    type: 'CLICKBACK_FAILURE'
  };
}

//thunk action creator
function sendClickback(email) {
  //SAMPLE: guestId = 'test%40test.com', entityCode = 'ESPN_Level1_GeneralPermission', langPref = 'en-us'
  return function (dispatch, getState) {
    dispatch(storeEmail(email));
    if (!_.isEmpty(email)) {
      let params = window.queryParams;
      // use this param to generate a quickly expiring link
      // params = ["overrideEmailValidationExpiration=5"];

      let url = buildClickbackURL(encodeURIComponent(email), window.langPref, params);
      let headers = buildHeaders();

      return fetch(url, {
        method: 'GET',
        redirect: 'follow',
        headers: new Headers(headers)
      }).then(function(response) {
        if (response.status !== 200) {
          dispatch(handleClickbackFailure());
          console.log('Looks like there was a problem. ', response);
        } else {
          dispatch(handleClickbackSuccess());
        }
      }).catch(function(error) {
        dispatch(handleClickbackFailure());
        console.log('Looks like there was a problem. ', error);
      });
    } else {
      console.log('Invalid email');
      dispatch(handleClickbackFailure());
      return new Promise(function(resolve, reject) {
        resolve();
      });
    }
  };
}

export {
  storeEmail,
  storeLegalCountry,
  storeCountryBloc,
  storeLoggedInName,
  storeGuestId,
  sendClickback,
  handleClickbackFailure,
  handleClickbackSuccess
};



// WEBPACK FOOTER //
// ./client/src/actions/app.js